angular.module('impactx.catalogruleresult').controller('CatalogRuleUnitsListCtrl',
    CatalogRuleUnitsListCtrl);

CatalogRuleUnitsListCtrl.$inject = ['$routeParams'];

function CatalogRuleUnitsListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruleunitslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruleunitslist',
        id: "catalogruleunitslist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}